/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.13.2.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export interface CitiesController_SetCurrentCityRequest {
  id: number | null;
  name: string | null;
}

export interface LabomatLocationResponse {
  id: string;
  address: string | null;
  longitude: number;
  latitude: number;
}

export interface SupportingInfo {
  documentTypeResponses: DocumentTypeResponse[] | null;
  typeMarksInfoes: TypeMarksInfo[] | null;
  privateAgreementInfo: { [key: string]: PrivateAgreementResponse } | null;
}

export interface TypeMarksInfo {
  /** Тип информации */
  type: ServiceSupportingInfoTypeEnum;
  /** Дополнительные маркеры валидации (обязательный, возрастное ограничение и пр.) */
  marks: ServiceSupportingInfoMarkTypeEnum[] | null;
}

/** Модель для отправки обратной связи с формы "LabPass" */
export interface B2BLabPassFeedbackModel {
  /** Имя */
  name: string;
  /** Email */
  email: string;
  /** Текст обратной связи (необязательное поле). */
  comment: string | null;
}

/** Модель для отправки обратной связи с формы "Сотрудничество с Хеликс" */
export interface B2BPartnershipFeedbackModel {
  /** Название города */
  city: string;
  /** Имя */
  name: string;
  /** Телефон или Email */
  contact: string;
}

/** Модель для отправки обратной связи с формы "Сотрудничество с Хеликс" */
export interface B2bInsuranceFeedbackModel {
  /** Название города */
  city: string;
  /** Название организации */
  organization: string;
  /** ФИО */
  name: string;
  /** Телефон */
  phone: string;
  /** Email(необязательное поле) */
  email: string | null;
  feedbackMessage: string | null;
}

export interface CancelAppointmentCommand {
  preorderNumber: string | null;
  lastName: string | null;
  cellPhone: string | null;
}

/** Информация о трудозанятости */
export interface Employment {
  /** Тип занятости */
  employmentType: EmploymentType;
  /** Информация о рабочей деятельности */
  work: Work | null;
  /** Информация об учебной деятельности */
  study: Study | null;
}

/** Тип занятости */
export enum EmploymentType {
  Work = 'Work',
  Study = 'Study',
  Free = 'Free',
}

/** Тип законного представителя */
export enum LegalRepresentativeTypeEnum {
  Mother = 'Mother',
  Father = 'Father',
  Guardian = 'Guardian',
  AdoptiveParent = 'AdoptiveParent',
  Trustee = 'Trustee',
}

export interface NewPreorderCommand {
  accounts: SelectedAccountModel[] | null;
  utc: number;
  city: string | null;
  cityId: number;
  googleRecaptchaResponse: string | null;
  policy: SelectedPolicyModel | null;
  user: SelectedUserModel | null;
  document: SelectedDocumentModel | null;
  /** Информация о трудозанятости */
  employment: Employment | null;
  arrival: SelectedArrivalModel | null;
  legalRepresentative: SelectedLegalRepresentativeModel | null;
}

/** Тип полиса */
export enum PolicyType {
  Old = 'Old',
  Temporary = 'Temporary',
  Uniform = 'Uniform',
}

export interface SelectedArrivalModel {
  arrival: boolean;
  arrivalCountry: string | null;
  arrivalDate: Date | null;
}

export interface SelectedLegalRepresentativeModel {
  /** Тип законного представителя */
  legalRepresentative: LegalRepresentativeTypeEnum;
  personalDataId: number | null;
  legalRepresentativeFirstName: string | null;
  legalRepresentativeLastName: string | null;
  legalRepresentativeMiddleName: string | null;
  /** Общее перечисление, описывающее пол клиента. */
  legalRepresentativeGender: Gender;
  legalRepresentativeBirthday: Date;
  legalRepresentativePhone: string | null;
  legalRepresentativeEmail: string | null;
}

export interface SelectedPolicyModel {
  /** Тип полиса */
  policyType: PolicyType;
  policySeries: string | null;
  policyNumber: string | null;
}

/** Информация об учебной деятельности */
export interface Study {
  address: string | null;
  group: string | null;
  place: string | null;
}

/** Информация о рабочей деятельности */
export interface Work {
  place: string | null;
  address: string | null;
  isAddressMatch: boolean;
  phone: string | null;
  position: string | null;
}

/** Перечисление типов записи на услугу */
export enum AppointmentServiceType {
  Default = 'Default',
  Ct = 'Ct',
  Mri = 'Mri',
  Vaccination = 'Vaccination',
  Covid = 'Covid',
  DoublePcr = 'DoublePcr',
}

export interface OnlinePaymentModel {
  available: boolean;
}

/** Тип идентифицирующего документа */
export enum PersonalIdType {
  PASS_RU = 'PASS_RU',
  PASS_ZAG = 'PASS_ZAG',
  PASS_INOS = 'PASS_INOS',
  SIVD_ROZHD = 'SIVD_ROZHD',
  UD_KZX = 'UD_KZX',
  PASS_KZX = 'PASS_KZX',
}

export interface SelectedAccountModel {
  hxid: string | null;
  accountCode: string | null;
  cabinetCode: string | null;
  practitionerCode: string | null;
  appointmentDate: Date;
  timeSlot: TimeSlotModel | null;
}

export interface SelectedDocumentModel {
  /** Тип идентифицирующего документа */
  personalIdType: PersonalIdType;
  personalIdFirstName: string | null;
  personalIdLastName: string | null;
  personalIdNumber: string | null;
  personalIdGiver: string | null;
  registrationAddress: string | null;
  address: string | null;
  regAddressMatch: boolean;
  personalIdDate: Date;
  snilsNumber: string | null;
}

export interface SelectedUserModel {
  firstName: string | null;
  lastName: string | null;
  middleName: string | null;
  birthDate: Date;
  /** Общее перечисление, описывающее пол клиента. */
  gender: Gender;
  cellPhone: string | null;
  email: string | null;
  personalDataId: number | null;
}

/** Информация о локации для записи */
export interface LocationInfo {
  /** Код локации */
  code: string | null;
  /** Имя локации */
  name: string | null;
  /** Адрес локации */
  address: string | null;
  /** Доступность онлайн оплаты */
  onlinePaymentAvailable: boolean;
  /** Широта - долгота */
  geoLocationInfo: GeoLocationInfo | null;
  /** Станции метро */
  subwayStationInfoes: SubwayStationInfo[] | null;
}

export interface SubwayStationInfo {
  code: string | null;
  name: string | null;
}

export interface TimeSlotModel {
  beginHours: number;
  beginMinutes: number;
  endHours: number;
  endMinutes: number;
}

export interface GetCabinetInfoQuery {
  hxid: string | null;
  city: string | null;
  cityId: number;
  accountCode: string | null;
  appointmentDate: Date;
  timeSlot: TimeSlotModel | null;
}

export interface AppointmentInfo {
  accountName: string | null;
  accountAddress: string | null;
  appointmentDate: Date;
  beginHours: number;
  beginMinutes: number;
}

export interface CabinetInfoResponse {
  cabinetCode: string | null;
  practitionerCode: string | null;
}

export interface CovidPreorderResponse {
  preorderStatus: CovidPreorderStatus;
  appointmentInfo: AppointmentInfo[] | null;
  additionalPreorderInfo: string | null;
}

export enum CovidPreorderStatus {
  Create = 'Create',
  TimeSlotLockByOtherUser = 'TimeSlotLockByOtherUser',
  TimeSlotNoFreeTime = 'TimeSlotNoFreeTime',
  TestRequestAlreadyCreatedForTodayTwice = 'TestRequestAlreadyCreatedForTodayTwice',
  TestRequestAlreadyCreatedForDateTwice = 'TestRequestAlreadyCreatedForDateTwice',
  VaccinationRequestAlreadyCreatedForTodayOnce = 'VaccinationRequestAlreadyCreatedForTodayOnce',
  VaccinationRequestAlreadyCreatedForDateOnce = 'VaccinationRequestAlreadyCreatedForDateOnce',
  FanIdIdNotExists = 'FanIdIdNotExists',
  UefaRequestAlreadyCreatedForDateOnce = 'UefaRequestAlreadyCreatedForDateOnce',
  InvalidTimeSlot = 'InvalidTimeSlot',
  OverlapAppointment = 'OverlapAppointment',
}

export interface CovidPriceResponse {
  hxid: string | null;
  title: string | null;
  currency: CurrencyModel | null;
  freeMobileServiceDate: string | null;
  price: number;
  isMobilePriceItem: boolean;
  available: boolean;
  companionBiomaterialServices: CompanionBiomaterialServiceModel[] | null;
  onlinePayment: OnlinePaymentModel | null;
}

export interface DocumentTypeResponse {
  id: string | null;
  description: string | null;
}

export interface GetAppointmentResponse {
  prefix: number;
  number: number;
}

export interface PrivateAgreementResponse {
  isMedical: boolean;
}

/** Дополнительная информация для входной информации(инпута) */
export enum ServiceSupportingInfoMarkTypeEnum {
  AdultOnly = 'AdultOnly',
  Snils = 'Snils',
  VaccinationCaption = 'VaccinationCaption',
  InternationalPassportWithLatinFio = 'InternationalPassportWithLatinFio',
  MiddleNameNotRequired = 'MiddleNameNotRequired',
}

/** Типы входных данных, участвующие в пайплайне записи */
export enum ServiceSupportingInfoTypeEnum {
  Document = 'Document',
  User = 'User',
  Workplace = 'Workplace',
  Arrival = 'Arrival',
  Policy = 'Policy',
  Account = 'Account',
}

export enum SlotType {
  FirstVisit = 'FirstVisit',
  SecondVisit = 'SecondVisit',
}

/** Метки валидации */
export enum ValidationMarkTypeEnum {
  BetweenFirstAndSecondMax21Days = 'BetweenFirstAndSecondMax21Days',
  BetweenFirstAndSecondMin1Days = 'BetweenFirstAndSecondMin1Days',
}

/** Информация о наблюдении */
export interface ObservationDefinition {
  /** Идентификатор номенклатуры */
  hxid: string | null;
  /** Наименование */
  name: string | null;
  /** Количество записей в рамках полного наблюдения */
  multipleVisits: SlotInfo[] | null;
}

/** Информация об услуге В рамках услуги существует подмножество записей/наблюдений */
export interface ServiceInfo {
  /** Возможность выбора нескольких записей/наблюдений */
  multipleObservationsAllowed: boolean;
  /** Доступные записи/наблюдения. Может быть пустым */
  availableObservations: ObservationDefinition[] | null;
}

/** Информация о временном слоте */
export interface SlotInfo {
  /** Тип слота */
  slotType: SlotType;
  /** Правила валидации */
  validation: ValidationInfo[] | null;
  /** Описание/пояснение (для отображения на UI) */
  description: string | null;
}

/** Свободное окно записи */
export interface TimeSlot {
  /** Время начала записи (локальное) */
  begin: Date;
  /** Время окончания записи (локальное) */
  finish: Date;
}

/** Информация по валидации временного слота */
export interface ValidationInfo {
  /** Метки валидации */
  markType: ValidationMarkTypeEnum;
  errorMessage: string | null;
}

/** Описывает авторизационные данные пользователя */
export interface EnterCommand {
  /** E-mail предполагаемого пользователя */
  email: string;
  /** Хеш пароля */
  passwordHash: string;
}

export enum EnterStatus {
  SuchUserNotRegisteredAsClient = 'SuchUserNotRegisteredAsClient',
  AccountNotActivated = 'AccountNotActivated',
  UserWithSuchEmailAndPasswordNotFound = 'UserWithSuchEmailAndPasswordNotFound',
}

export interface EnterResponse {
  webAccountId: number;
}

export interface AddItemToCartCommand {
  hxid: string | null;
  cityId: number;
}

export interface AddItemWithConfirmationCommand {
  hxid: string | null;
  cityId: number;
}

/** Описывает параметры, необходимые для завершения корзины */
export interface CompleteCartCommand {
  cityId: number;
  revision: number;
}

/** Модель, содержащая иформацию, необходимую для оформления предзаказа с оплатой онлайн */
export interface CompleteOnlineCartCommand {
  cityId: number;
  revision: number;
  idempotencyKey: string;
}

export interface CreateInvoiceCommand {
  cityId: number;
  revision: number;
}

export interface DeleteInvoiceCommand {
  cityId: number;
  revision: number;
}

export interface SetChoosenRuleCommand {
  cartItemId: number;
  ruleId: number;
  cityId: number;
}

export interface SetMobileServiceCommand {
  date: Date | null;
  cityId: number;
}

/** Модель обновления услуги-контейнера */
export interface UpdateContainerCommand {
  /** Идентификатор услуги */
  serviceId: number;
  /** Признак включенности в корзину */
  isIncludeInCart: boolean;
}

/** Тип hxid-а */
export enum CartItemType {
  Analyse = 'Analyse',
  Complex = 'Complex',
  Service = 'Service',
}

/** Описывает выбранный клиентом способ оплаты предзаказа */
export enum CartPaymentType {
  Offline = 'Offline',
  Online = 'Online',
}

/** Перечисление, описывающее пол клиента */
export enum ClientGender {
  Male = 'Male',
  Female = 'Female',
  None = 'None',
}

/** Модель описывает результат добавления анализа в корзину */
export interface AddedItemResponse {
  /** Статус попытки добавления элемента в корзину */
  cartItemResultStatus: CartItemResultStatus;
  message: string | null;
}

export interface AgreementResponse {
  hasPrivateAgreement: boolean;
  hasUserAgreement: boolean;
  hasMedicalServiceAgreement: boolean;
  hasNotMedicalServiceAgreement: boolean;
}

/** Модель описывает контейнер */
export interface BiomaterialContainer {
  id: number;
  hxid: string | null;
  title: string | null;
  price: number;
  currency: string | null;
  isAdded: boolean;
}

/** Модель описывает всю необходимую информацию о стоимости анализов и услуг */
export interface CartCostInfo {
  currency: string | null;
  pointToCredit: number | null;
  /** Описывает конкретно цены и стоимость */
  cartCost: CostInfo | null;
}

/** Модель описывает состав корзины */
export interface CartInfoResponse {
  revision: number;
  isAnonym: boolean;
  preorderAvailability: boolean;
  /** Описывает выбранный клиентом способ оплаты предзаказа */
  paymentType: CartPaymentType;
  mobileServiceAvailability: boolean;
  invoiceId: string | null;
  /** Модель описывает всю необходимую информацию о стоимости анализов и услуг */
  cost: CartCostInfo | null;
  items: CartItemInfo[] | null;
  services: CartItemService[] | null;
  containers: BiomaterialContainer[] | null;
}

/** Модель описывает анализ в корзине */
export interface CartItemInfo {
  id: number;
  hxid: string | null;
  title: string | null;
  price: number;
  currency: string | null;
  processingTime: string | null;
  /** Тип hxid-а */
  cartItemType: CartItemType;
  ruleSelector: CartRule[] | null;
  parts: ComplexPart[] | null;
}

/** Статус попытки добавления элемента в корзину */
export enum CartItemResultStatus {
  Error = 'Error',
  Added = 'Added',
  Duplicate = 'Duplicate',
  InComplex = 'InComplex',
  RedirectToInformationPage = 'RedirectToInformationPage',
}

/** Описывает услугу в корзине */
export interface CartItemService {
  id: number;
  hxid: string | null;
  title: string | null;
  price: number;
  currency: string | null;
}

/** Описывает правило (биоматериал), доступное для выбора клиентом */
export interface CartRule {
  ruleId: number;
  description: string | null;
  isSelected: boolean;
}

export interface CompleteCartResponse {
  fullPreOrderNumber: string | null;
  isSendEmail: boolean;
  isMobileService: boolean;
}

/** Результат выполнения метода завершения предзаказа с оплатой онлайн */
export interface CompleteOnlineCartResponse {
  confirmationUrl: string | null;
}

/** Описывает составную часть комплекса */
export interface ComplexPart {
  hxid: string | null;
  description: string | null;
}

/** Описывает конкретно цены и стоимость */
export interface CostInfo {
  resultCost: number;
  analyseCost: number;
  serviceCost: number;
  containerCost: number;
}

/** Модель ошибок валидации, при */
export interface FieldError {
  fieldName: string | null;
  errorMessage: string | null;
}

export interface FullCartInfoResponse {
  revision: number;
  isAnonym: boolean;
  preorderAvailability: boolean;
  /** Описывает выбранный клиентом способ оплаты предзаказа */
  paymentType: CartPaymentType;
  /** Модель описывает всю необходимую информацию о стоимости анализов и услуг */
  cost: CartCostInfo | null;
  patientPreparations: string[] | null;
  items: CartItemInfo[] | null;
  services: CartItemService[] | null;
  /** Результирующая модель с данными профиля */
  clientInfo: ProfileInfoResponse | null;
  mobileServiceInfo: MobileServiceInfo | null;
  agreements: AgreementResponse | null;
}

export interface GetCartCustomersInfoResponse {
  /** Список профилей, прикреплённых к учётной записи (если клиент не авторизован в списке всегда будет
только одна запись с теми данными, которые клиент ввёл на форме) */
  profilesList: ProfileInfoResponse[] | null;
  /** Дополнительные электронные адреса (может быть получено только для авторизованных клиентов) */
  additionalEmails: string[] | null;
  /** Дополнительные номера телефонов (может быть получено только для авторизованных клиентов) */
  additionalPhoneNumbers: string[] | null;
  /** Информация о заказе выезда мобильной службы (можно указывать только для оффлайн-предзаказов) */
  mobileServiceInfo: MobileServiceInfoResponse | null;
}

/** Результат выполнения команды по созданию инвойса */
export interface InvoiceResponse {
  /** Идентификатор инвойса */
  invoiceId: string;
}

export interface MobileServiceAddress {
  isSelected: boolean;
  address: string | null;
}

export interface MobileServiceInfo {
  mobileServiceChecked: boolean;
  checkedDate: Date | null;
  address: string | null;
}

export interface MobileServiceInfoResponse {
  isSelected: boolean;
  mobileServiceDate: Date | null;
  addresses: MobileServiceAddress[] | null;
}

/** Описывает результат получения количества анализов в корзине */
export interface PreOrderItemsCountResponse {
  count: number;
}

/** Результирующая модель с данными профиля */
export interface ProfileInfoResponse {
  isSelected: boolean;
  profileId: number | null;
  firstName: string | null;
  lastName: string | null;
  middleName: string | null;
  birthdate: Date | null;
  /** Перечисление, описывающее пол клиента */
  gender: ClientGender;
  email: string | null;
  cellPhone: string | null;
}

/** Описывает результат удаления анализа из корзины */
export interface RemoveCartItemResponse {
  cartItemsCount: number;
}

/** Результат сохранения данных клиента в корзине */
export interface SaveCartCustomerInfoResponse {
  fieldErrors: FieldError[] | null;
  hasAccount: boolean;
}

export enum NomenclatureGroup {
  Default = 'Default',
  Covid19 = 'Covid19',
  Antibodies = 'Antibodies',
  Vaccination = 'Vaccination',
  AfterCovid19 = 'AfterCovid19',
  ImmuneStatus = 'ImmuneStatus',
}

export interface CatalogFilter {
  categoryId: number;
  attributeIds: number[] | null;
}

export interface KbDrugGroupModel {
  groupName: string | null;
  kbDrugInfluenceItems: KbDrugInfluenceModel[] | null;
}

export interface KbDrugInfluenceModel {
  title: string | null;
  influenceLevel: string | null;
}

export interface KbNomenclatureInfoModel {
  shortDescription: string | null;
  containerUrl: string | null;
  inKnowlengeBase: boolean;
  unit: string | null;
  resultsInterpretation: string | null;
}

export interface NomenclatureComplexPartModel {
  hxid: string | null;
  title: string | null;
}

export interface NomenclatureInfoModel {
  itemTitle: string | null;
  russianSynonyms: string | null;
  englishSynonyms: string | null;
}

export interface NomenclatureSpecialFields {
  recommendations: string[] | null;
  benefits: string[] | null;
}

export interface OnlinePaymentInfo {
  availability: PreorderAvailabilityStatus;
}

export interface PaginationInfo {
  lastId: number | null;
  itemCount: number | null;
}

export interface PopularItemPriceInfo {
  value: number;
  currencyCode: string | null;
  currencySymbol: string | null;
}

export enum PreorderAvailabilityStatus {
  Available = 'Available',
  OnlyInDiagnosticCenter = 'OnlyInDiagnosticCenter',
  NotAvailable = 'NotAvailable',
  MobileService = 'MobileService',
  OnlyForAppointment = 'OnlyForAppointment',
}

export interface StatisticIndexModel {
  value: number | null;
  accuracy: string | null;
}

export interface TestSystemModel {
  name: string | null;
  country: string | null;
  manufacturer: string | null;
  result: string | null;
  specificity: StatisticIndexModel | null;
  sensitivity: StatisticIndexModel | null;
}

export interface GetCatalogListItemsQuery {
  cityId: number;
  filter: CatalogFilter | null;
  pagination: PaginationInfo | null;
}

export interface GetNomenclatureSimpleListQuery {
  city: string | null;
  cityId: number;
  hxids: string[];
}

export interface GetNomenclaturesByGroupQuery {
  city: string | null;
  cityId: number;
  groupType: NomenclatureGroup;
}

export interface AttributeNode {
  id: number;
  name: string | null;
}

export interface CatalogListItemResponse {
  id: number;
  hxid: string | null;
  title: string | null;
  price: number;
  currency: CurrencyModel | null;
  estimateInfo: string | null;
  isComplex: boolean;
  canPreOrder: boolean;
}

export interface GetCatalogCategoriesResponse {
  id: number;
  description: string | null;
  urlPart: string | null;
}

export interface GetCatalogCategoryAttributesResponse {
  attributes: AttributeNode[] | null;
  title: string | null;
}

export interface GetPricesResponse {
  /** Валюта для цен в регионе */
  currency: string | null;
  /** Количество номенклатур */
  count: number;
  /** Номенклатуры */
  priceItems: NomenclaturePriceInfo[] | null;
}

export interface HelixExpressHxidAvailabilityResponse {
  hxid: string | null;
  isAvailable: boolean;
}

export interface NomenclatureAttributesResponse {
  appointmentRequired: boolean;
  snilsRequired: boolean;
  covIDCompatible: boolean;
  isExpress: boolean;
  compatibleWithGosuslugi: boolean;
  anonymousForbidden: boolean;
  /** Перечисление типов записи на услугу */
  appointmentType: AppointmentServiceType;
}

/** Описывает краткую информацию о Номенклатуре */
export interface NomenclaturePriceInfo {
  /** Идентификатор номенклатуры */
  hxid: string | null;
  /** Название номенклатуры */
  title: string | null;
  /** Цена */
  price: number;
  /** Время выполнения */
  processingTime: string | null;
}

export interface NomenclatureResponse {
  hxid: string | null;
  city: string | null;
  nomenclatureGroup: NomenclatureGroup;
  currency: CurrencyModel | null;
  deadline: string | null;
  geneticComplexInfoFile: string | null;
  price: number;
  isBiomaterialService: boolean;
  hasExampleFile: boolean;
  specialFields: NomenclatureSpecialFields | null;
  testSystems: TestSystemModel[] | null;
  attributes: NomenclatureAttributesResponse | null;
  nomenclatureInfo: NomenclatureInfoModel | null;
  kbNomenclatureInfo: KbNomenclatureInfoModel | null;
  preorderAvailability: PreorderAvailabilityStatus;
  metadataInfo: NomenclatureMetadataModel | null;
  onlinePaymentInfo: OnlinePaymentInfo | null;
  explorationMethods: string[] | null;
  patientPreparations: string[] | null;
  parts: NomenclatureComplexPartModel[] | null;
  drugInfluenceGroups: KbDrugGroupModel[] | null;
  biomaterialRules: FullBiomaterialRuleDto[] | null;
  companionBiomaterialServices: CompanionBiomaterialServiceModel[] | null;
  servicePricesInfo: ServiceCostPredictionDto | null;
}

export interface NomenclatureSimpleResponse {
  price: number;
  hxid: string | null;
  title: string | null;
  processingTime: string | null;
}

export interface PopularItemResponse {
  hxid: string | null;
  imageUrl: string | null;
  title: string | null;
  subTitle: string | null;
  price: PopularItemPriceInfo | null;
}

export interface AccountScheduleResponse {
  /** Название услуги в расписании */
  service: string | null;
  /** Режим приёма */
  description: string | null;
  /** Расписание смен */
  shifts: AccountScheduleShiftsResponse[] | null;
}

export interface AccountScheduleShiftsResponse {
  /** День расписания */
  day: Date;
  /** Время работы смены */
  workHours: AccountScheduleWorkHoursResponse | null;
}

export interface AccountScheduleWorkHoursResponse {
  startShift: Date;
  endShift: Date;
}

export interface AccountTagCategoryResponse {
  id: number;
  name: string | null;
  tags: AccountTagResponse[];
}

export interface AccountTagResponse {
  id: number;
  name: string;
  position: number;
  accountCodes: string[];
}

/** Описывает список мест забора */
export interface AccountWithAvailableNomenclaturesResponse {
  code: string | null;
  name: string | null;
  address: string | null;
  latitude: number;
  longitude: number;
  subwayStations: MetroStationResponse[] | null;
  paymentTypes: PaymentType[] | null;
}

export interface CityAccountCountResponse {
  id: number;
  name: string | null;
  geoLocationInfo: GeoLocationInfo | null;
  centersCount: number;
}

export interface GeoLocationInfo {
  latitude: number;
  longitude: number;
}

export interface GetCenterPromotionResponse {
  id: number;
  title: string | null;
  description: string | null;
}

export interface GetCenterResponse {
  code: string | null;
  cityId: number;
  name: string | null;
  address: string | null;
  geoLocationInfo: GeoLocationInfo | null;
  isMobileService: boolean;
  subwayStations: MetroStationResponse[] | null;
  schedule: AccountScheduleResponse[] | null;
  scheduleAlertMessage: string | null;
  workHours: WorkHoursResponse | null;
  images: string[] | null;
  routeToCenter: string | null;
  legalInfo: LegalInfoResponse | null;
  /** Информация о возможностях оплаты в диагностическом центре */
  payment: PaymentResponse | null;
}

export interface GetCentersResponse {
  code: string | null;
  name: string | null;
  address: string | null;
  workHours: WorkHoursResponse | null;
  geoLocationInfo: GeoLocationInfo | null;
  subwayStations: MetroStationResponse[] | null;
}

export interface LegalInfoResponse {
  title: string | null;
  info: string | null;
  tradeName: string | null;
  address: string | null;
  licenceInfo: string | null;
  services: string | null;
  paymentInfo: string | null;
  staffInfo: string | null;
  referenceInformation: string | null;
}

export interface MetroStationResponse {
  code: string | null;
  name: string | null;
}

/** Информация о возможностях оплаты в диагностическом центре */
export interface PaymentResponse {
  byCash: AccountPaymentStatus;
  byPoints: AccountPaymentStatus;
  byCard: AccountPaymentStatus;
  byCardCustomStatus: string | null;
}

export interface WorkHoursResponse {
  start: Date | null;
  end: Date | null;
}

export interface CityResponse {
  id: number;
  name: string | null;
  federalPhone: string | null;
  companyPhone: string | null;
  isImportant: boolean;
  isParent: boolean;
  alias: string | null;
  countryCode: string | null;
  isVisibleForCustomers: boolean;
  isHelixLite: boolean;
  isPractitionerAppointmentAvailable: boolean;
}

/** TODO: Временно. Удалить после редизайна ЛКК */
export interface MyCityResponse {
  id: number;
  name: string | null;
  isImportant: boolean;
  isParent: boolean;
}

/** Перечисление описывает возможные ошибки бизнес-логики, которые необходимо отобразить пользователю в виде понятного сообщения */
export enum BusinessLogicStatus {
  CityIdNotFound = 'CityIdNotFound',
  CannotCreateOrder = 'CannotCreateOrder',
  CannotGetInvoice = 'CannotGetInvoice',
  CannotCreateInvoice = 'CannotCreateInvoice',
  ProfileNotExists = 'ProfileNotExists',
  RecaptchaRequestFromBot = 'RecaptchaRequestFromBot',
  InvalidFileExtension = 'InvalidFileExtension',
  SumFileSizeExceedsMaxValue = 'SumFileSizeExceedsMaxValue',
  WebAccountNotFound = 'WebAccountNotFound',
  CityNameNotFound = 'CityNameNotFound',
  SomeItemFromCartMissingFromDb = 'SomeItemFromCartMissingFromDb',
  NotDiagnosticCenterIsAvailableForCartWithSelectedPaymentType = 'NotDiagnosticCenterIsAvailableForCartWithSelectedPaymentType',
  CartNotFoundOrDeleted = 'CartNotFoundOrDeleted',
  ReturnToFirstStepAndChooseAnyBiomaterial = 'ReturnToFirstStepAndChooseAnyBiomaterial',
  CartHasAnotherPaymentType = 'CartHasAnotherPaymentType',
  IncorrectRevision = 'IncorrectRevision',
  AnyProfileRequiredInAccount = 'AnyProfileRequiredInAccount',
  UserAccountNotFound = 'UserAccountNotFound',
  CartMustContainClientsData = 'CartMustContainClientsData',
  ChooseOfflinePaymentType = 'ChooseOfflinePaymentType',
  ProfileNotFound = 'ProfileNotFound',
  OrderHasAlreadyBeenSaved = 'OrderHasAlreadyBeenSaved',
  ChooseClientProfile = 'ChooseClientProfile',
  EmailAndPhoneRequiredToOnlinePayment = 'EmailAndPhoneRequiredToOnlinePayment',
  CovidRedirectRu = 'CovidRedirectRu',
  CovidRedirectKz = 'CovidRedirectKz',
  MobileServiceNotFound = 'MobileServiceNotFound',
}

/** Перечисление описывает возможные коды ошибок при валидации данных */
export enum CommonValidationStatus {
  Required = 'Required',
  TooLarge = 'TooLarge',
  TooShort = 'TooShort',
  InvalidFormat = 'InvalidFormat',
  DateCannotBeInFuture = 'DateCannotBeInFuture',
  DateMustBeGreaterThanNow = 'DateMustBeGreaterThanNow',
  DateMustBeGreaterOrEqualToday = 'DateMustBeGreaterOrEqualToday',
  ValueMustBeGreaterThanZero = 'ValueMustBeGreaterThanZero',
  IncorrectDateInterval = 'IncorrectDateInterval',
}

/** Общее перечисление, описывающее пол клиента. */
export enum Gender {
  Male = 'Male',
  Female = 'Female',
}

export interface CurrencyModel {
  code: string | null;
  name: string | null;
  symbol: string | null;
}

export interface NomenclatureMetadataModel {
  metaTitle: string | null;
  metaDescription: string | null;
  metaKeywords: string | null;
}

export interface PaginationFilter {
  take: number;
  skip: number;
}

export interface HostsModel {
  main: string | null;
  personalAccount: string | null;
  doctorAccount: string | null;
  login: string | null;
  b2b: string | null;
}

export interface WebimModel {
  accountName: string | null;
  domain: string | null;
}

export enum YandexMapsLocale {
  Ru_RU = 'ru_RU',
  Ru_UA = 'ru_UA',
  En_US = 'en_US',
  En_RU = 'en_RU',
  Uk_UA = 'uk_UA',
  Tr_TR = 'tr_TR',
}

export interface YandexMapsModel {
  apiKey: string | null;
  locale: YandexMapsLocale;
}

export interface ClientStorage {
  isUserLoggedIn: boolean;
}

export interface ConfigurationResponse {
  recaptchaPublicKey: string | null;
  hosts: HostsModel | null;
  webim: WebimModel | null;
  clientStorage: ClientStorage | null;
  featureFlags: string[] | null;
  yandexMaps: YandexMapsModel | null;
}

export interface MyConfigurationResponse {
  /** Отправлен запрос на удаление аккаунта */
  isWebAccountOnDelete: boolean;
  /** Нужно ли показывать опрос */
  showInterview: boolean;
  /** Нужно ли показывать окно о добавлении карты */
  showAddCardForm: boolean;
  /** Нужно ли показывать форму смены пароля */
  showChangePasswordForm: boolean;
  /** Надо ли показывать в меню кнопку "Объединить аккаунты" */
  showCombineAccountsMenu: boolean;
}

export interface CountryResponse {
  name: string | null;
  listEntryID: string | null;
}

export interface DynamicsFilterRequest {
  from: Date | null;
  to: Date | null;
}

export interface GetDynamicsRequest {
  profileId: number;
  /** Название теста */
  testName: string | null;
  /** Название показателя */
  indexName: string | null;
  /** Фильтр по дате */
  filter: DynamicsFilterRequest | null;
}

export interface DynamicsItem {
  name: string | null;
  date: Date | null;
  orderCode: string | null;
  hxid: string | null;
  numericResult: DynamicsItemNumericResult | null;
  textResult: DynamicsItemTextResult | null;
}

export interface DynamicsItemNumericResult {
  value: number;
  units: string | null;
  reference: DynamicsItemReference | null;
}

export interface DynamicsItemReference {
  min: string | null;
  max: string | null;
}

export interface DynamicsItemTextResult {
  value: string | null;
  units: string | null;
  reference: DynamicsItemReference | null;
  commentReference: string | null;
}

export enum DynamicsResultStatus {
  Numeric = 'Numeric',
  Text = 'Text',
}

export interface GetDynamicsResponse {
  indexName: string | null;
  testName: string | null;
  status: DynamicsResultStatus;
  items: DynamicsItem[] | null;
}

export interface GetTestsResponse {
  /** Анализ */
  testName: string | null;
  /** Показатели */
  indexNames: string[] | null;
}

export interface SendInterviewRequest {
  answerOne: number;
  answerTwo: number;
  answerThree: number;
  message: string | null;
}

export enum SendInterviewError {
  Unauthorized = 'Unauthorized',
}

export interface SendInterviewErrorResponse {
  error: SendInterviewError;
}

export interface ApplyJobResponse {}

export interface JobResponse {
  name: string | null;
  requirements: string | null;
}

export interface GetArticleInterpretationInfoResponse {
  title: string;
  text: string;
}

/** Тип сообщения */
export enum UserFeedbackMessageType {
  Question = 'Question',
  Proposal = 'Proposal',
  Complaint = 'Complaint',
  Gratitude = 'Gratitude',
  WebsiteError = 'WebsiteError',
  IssuingCertificate = 'IssuingCertificate',
  TestCanceling = 'TestCanceling',
}

export interface MobileServiceFeedbackCommand {
  name: string | null;
  city: string | null;
  phone: string | null;
  googleRecaptchaResponse: string | null;
  userId: string | null;
}

export interface MobileServiceFeedbackResponse {}

export interface MobileServicePageResponse {
  id: number;
  image: string | null;
  pageContent: string | null;
  keyWords: string | null;
  title: string | null;
}

export interface NewsPreview {
  newsId: number;
  date: Date;
  title: string | null;
  description: string | null;
}

/** Входная модель для фильтрации при поиске новостей. TagId - ид тэга. NewsDate - дата публикации новости. Если поля пустые, фильтрация по ним не происходит. */
export interface NewsSearchFilter {
  tagId: number | null;
  newsDate: Date | null;
}

export interface NewsDatesSearchRequest {
  year: number;
  month: number;
  cityId: number;
}

export interface NewsSearchRequest {
  cityId: number;
  /** Входная модель для фильтрации при поиске новостей.
TagId - ид тэга.
NewsDate - дата публикации новости.
Если поля пустые, фильтрация по ним не происходит. */
  filter: NewsSearchFilter | null;
  pagination: PaginationFilter | null;
}

export interface NewsResponse {
  id: number;
  title: string | null;
  date: Date;
  content: string | null;
  tags: NewsTagResponse[] | null;
}

export interface NewsSearchResponse {
  count: number;
  data: NewsPreview[] | null;
}

export interface NewsTagResponse {
  id: number;
  name: string | null;
}

export interface CityModel {
  cityName: string | null;
  cityCode: string | null;
  cityId: number;
}

export interface CreateOnlineInvoiceCommand {
  cityModel: CityModel | null;
  hxids: string[] | null;
}

export interface CreateOnlineOrderCommand {
  idempotenceKey: string;
  invoiceId: string;
  city: string | null;
  cityId: number;
  utc: number;
  googleRecaptchaResponse: string | null;
  policy: SelectedPolicyModel | null;
  user: SelectedUserModel | null;
  document: SelectedDocumentModel | null;
  /** Информация о трудозанятости */
  employment: Employment | null;
  arrival: SelectedArrivalModel | null;
  legalRepresentative: SelectedLegalRepresentativeModel | null;
  accounts: SelectedAccountModel[] | null;
}

export interface InvoiceResponse2 {
  id: string;
  prices: { [key: string]: PriceInfo } | null;
}

export interface OrderResponse {
  confirmationUrl: string | null;
}

export interface PriceInfo {
  value: number;
  currencyCode: string | null;
}

export interface AddOrderToHistoryRequest {
  profileId: number;
}

export interface HideOrderFromHistoryRequest {
  profileId: number;
}

export interface RepeatOrderRequest {
  profileId: number;
  cityId: number;
  clearCartBeforeAdd: boolean;
}

export interface SendResultsToEmailRequest {
  lastName: string;
  orderCode: string;
  email: string;
}

export interface TryRepeatOrderRequest {
  profileId: number;
  cityId: number;
}

export interface AddOrderToHistoryErrorResponse {
  error: string | null;
}

export interface Dynamic {
  /** Показывать график или таблицу с динамикой
Если истина - то показывать график */
  isDynamicGraph: boolean;
  /** Единицы измерения */
  units: string | null;
  /** Список результатов по динамике */
  dynamics: DynamicResult[];
}

export interface DynamicResult {
  /** Код заказа */
  orderCode: string;
  /** Дата заказа */
  orderDate: Date;
  /** Номенклатура */
  hxid: string;
  /** Название теста */
  testName: string;
  /** Числовое значение */
  numericEntry: number | null;
  /** Отформатированное числовое значение */
  formattedEntry: string;
  /** Комментарий к референсному значению */
  referenceComment: string | null;
  /** Нижнее референсное значение */
  referenceLo: number | null;
  /** Верхнее референсное значение */
  referenceHi: number | null;
  /** Отформатированное нижнее референсное значение */
  formattedReferenceLo: string | null;
  /** Отформатированное верхнее референсное значение */
  formattedReferenceHi: string | null;
}

export enum GetComplexConclusionFilesError {
  Unauthorized = 'Unauthorized',
}

export enum GetResultsFilesError {
  Unauthorized = 'Unauthorized',
}

export enum RepeatOrderError {
  Unauthorized = 'Unauthorized',
}

export enum SendResultsToEmailByOrderCodeResponseType {
  Success = 'Success',
  SuccessAndHasConfirmedHiv = 'SuccessAndHasConfirmedHiv',
  HasConfirmedHiv = 'HasConfirmedHiv',
  Cancelled = 'Cancelled',
  NotReady = 'NotReady',
  NotFound = 'NotFound',
}

export enum SendResultsToEmailByProfileError {
  Unauthorized = 'Unauthorized',
}

export enum SendResultsToEmailByProfileResponseType {
  Success = 'Success',
  SuccessAndHasConfirmedHiv = 'SuccessAndHasConfirmedHiv',
  HasConfirmedHiv = 'HasConfirmedHiv',
  Cancelled = 'Cancelled',
  NotReady = 'NotReady',
}

export enum TryRepeatOrderError {
  Unauthorized = 'Unauthorized',
}

export enum TryRepeatOrderResponseType {
  ItemsAdded = 'ItemsAdded',
  AllItemsUnavailable = 'AllItemsUnavailable',
  AllItemsAlreadyInCart = 'AllItemsAlreadyInCart',
  HasUnavailableItems = 'HasUnavailableItems',
  CartHasItems = 'CartHasItems',
  HasAppointmentRequiredItems = 'HasAppointmentRequiredItems',
  HasAppointmentRequiredItemsAndRepeatableItems = 'HasAppointmentRequiredItemsAndRepeatableItems',
}

export interface GetComplexConclusionFilesErrorResponse {
  error: GetComplexConclusionFilesError;
}

export interface GetOrderComplexConclusionFilesResponseData {
  /** Код заказа */
  orderCode: string;
  /** Список позиций (HXID и код OrderItem), для которых доступны заключения */
  orderItems: OrderItemModel[];
}

export interface GetOrderFilesResponseData {
  /** Код заказа */
  orderCode: string;
  /** Почта клиента */
  email: string;
  /** Содержит результаты ВИЧ */
  hasConfirmedHivResults: boolean;
  /** Номер образца
В терминологии ТехПлатформы LabelId - это внешний номер, а SampleNumber - внутренний
Пользователю показываем LabelId */
  labelIds: string[];
}

export interface GetResultsFilesErrorResponse {
  error: GetResultsFilesError;
}

export interface ItemToRepeatInfo {
  hxid: string;
  name: string;
}

/** Заказ */
export interface Order {
  /** Код заказа */
  code: string;
  /** Фамилия */
  patientLastName: string;
  /** Имя */
  patientFirstName: string;
  /** Отчество */
  patientMiddleName: string;
  /** Пол */
  patientGender: Gender;
  /** Возраст */
  patientAge: number | null;
  /** Место выполнения */
  accountName: string | null;
  /** Договор */
  contractCode: string;
  /** Результаты */
  tests: Test[];
}

export interface OrderItemModel {
  orderItemId: number;
  hxid: string | null;
}

export interface PreOrderPreview {
  code: string;
  createdOn: Date;
  sum: number;
  currencyName: string;
  currency: CurrencyModel | null;
  items: OrderItemPreview[] | null;
}

export interface RepeatOrderErrorResponse {
  error: RepeatOrderError;
}

export interface Result {
  /** Показатель */
  name: string;
  /** Числовое значение */
  numericEntry: number | null;
  /** Отформатированное числовое значение */
  formattedEntry: string;
  /** Комментарий к референсному значению */
  referenceComment: string | null;
  /** Показывать ли график с результатами */
  showGraph: boolean;
  /** Нижнее референсное значение */
  referenceLo: number | null;
  /** Верхнее референсное значение */
  referenceHi: number | null;
  /** Отформатированное нижнее референсное значение */
  formattedReferenceLo: string | null;
  /** Отформатированное верхнее референсное значение */
  formattedReferenceHi: string | null;
  /** Единицы измерения */
  units: string | null;
}

export interface ResultWithDynamics {
  result: Result;
  dynamic: Dynamic | null;
}

export interface SendResultsToEmailByProfileErrorResponse {
  type: SendResultsToEmailByProfileError;
}

export interface SendResultsToEmailByProfileResponse {
  type: SendResultsToEmailByProfileResponseType;
}

export interface Test {
  name: string;
  hxid: string;
  kbId: number | null;
  results: ResultWithDynamics[];
}

export interface TryRepeatOrderErrorResponse {
  error: TryRepeatOrderError;
}

export interface TryRepeatOrderResponse {
  /** Тип ответа */
  type: TryRepeatOrderResponseType;
  /** Услуги, на которые нужна запись */
  readonly appointmentRequiredItems: ItemToRepeatInfo[];
}

export interface Appointment {
  /** Код ДЦ */
  accountCode: string;
  /** Название ДЦ */
  accountName: string | null;
  /** Адрес ДЦ */
  accountAddress: string | null;
  /** Дата и время приёма */
  dateTime: Date;
}

export interface CancelOrderErrorResponse {
  error: CancelOrderError;
}

/** ДЦ */
export interface Center {
  /** Код ДЦ */
  code: string;
  /** Название */
  name: string;
  /** Адрес */
  address: string | null;
  /** Широта */
  latitude: number | null;
  /** Долгота */
  longitude: number | null;
  /** Список кодов станций метро */
  subwayStationCodes: string[];
}

/** Город */
export interface City {
  /** Код */
  code: string;
  /** Название */
  name: string | null;
}

export interface DraftOrder {
  /** Код заказа */
  code: string;
  /** Пациент */
  patient: Person;
  /** Законный представитель */
  legalRepresentative: Person | null;
  /** Номер телефона в заказе */
  phone: string;
  /** Электронная почта в заказе */
  email: string;
  /** Город */
  city: City;
  /** Приём */
  appointment: Appointment | null;
  /** Дата оформления заказа */
  createdOn: Date;
  /** Статус оплаты */
  paymentStatus: DraftOrderPaymentStatus;
  /** Общая текущая сумма по заказу (может отличаться от InitialAmount после разморозки цены) */
  actualPrice: number;
  /** Первоначальная цена, действительная на момент оформления заказа и до окончания заморозки цены */
  initialPrice: number;
  /** Сумма внесенной оплаты */
  paymentAmount: number;
  /** Количество баллов, которое будет начислено за заказ */
  pointToCredit: number;
  /** Валюта */
  currency: CurrencyModel;
  canCancel: boolean;
  /** Можно ли отменить заказ */
  canCancelOrder: boolean;
  /** Можно ли отменить оплату */
  canCancelPayment: boolean;
  /** Стоимость оплаты изменилась */
  paymentAmountChanged: boolean;
  /** Дата, после которой могут измениться цены */
  priceFreezeDueDate: Date | null;
  /** Заказанные анализы */
  items: DraftOrderItem[];
  /** Заказанные услуги */
  biomaterialServices: DraftOrderItem[];
  /** Рекомендации по подготовке к исследованиям */
  preparations: string[];
}

export interface DraftOrderItem {
  /** Номенклатура */
  hxid: string;
  /** Наименование */
  title: string;
  /** Срок выполнения исследования */
  processingTime: string | null;
  /** Текущая цена */
  actualPrice: number;
  /** Первоначальная цена, действительная на момент оформления заказа и до окончания заморозки цены */
  initialPrice: number;
  /** Список исследований, входящих в комплекс */
  parts: DraftOrderItemPart[];
}

/** Дочернее исследование в комплексе */
export interface DraftOrderItemPart {
  /** Номенклатура */
  hxid: string;
  /** Наименование */
  title: string;
}

export enum CancelOrderError {
  Unauthorized = 'Unauthorized',
  ErrorDuringCancellation = 'ErrorDuringCancellation',
}

export enum DraftOrderPaymentStatus {
  Awaiting = 'Awaiting',
  Paid = 'Paid',
  Refunded = 'Refunded',
}

export enum GetOrderApiResponseTypeV2 {
  Draft = 'Draft',
  Results = 'Results',
  OrderHasConfirmedHiv = 'OrderHasConfirmedHiv',
  AllOrderItemsAreServices = 'AllOrderItemsAreServices',
  OrderResultsAreNotReady = 'OrderResultsAreNotReady',
}

export enum GetOrderCentersError {
  Unauthorized = 'Unauthorized',
  OrderHasAppointment = 'OrderHasAppointment',
}

export enum GetOrderErrorV2 {
  Unauthorized = 'Unauthorized',
}

export enum GetOrderPrintableVersionError {
  Unauthorized = 'Unauthorized',
}

export enum HideOrderFromHistoryErrorV2 {
  Unauthorized = 'Unauthorized',
}

export enum OrderStatusV2 {
  Unknown = 'Unknown',
  Created = 'Created',
  Paid = 'Paid',
  PaymentAwaiting = 'PaymentAwaiting',
  Confirmed = 'Confirmed',
  InProgress = 'InProgress',
  Cancelled = 'Cancelled',
  Completed = 'Completed',
}

export interface GetOrderApiResponseV2 {
  readonly responseType: GetOrderApiResponseTypeV2;
  /** Заказ */
  readonly results: Order | null;
  readonly draft: DraftOrder | null;
}

export interface GetOrderCentersErrorResponse {
  error: GetOrderCentersError;
}

export interface GetOrderCentersResponse {
  /** Список центров */
  centers: Center[];
}

export interface GetOrderErrorResponseV2 {
  error: GetOrderErrorV2;
}

export interface GetOrderPrintableVersionErrorResponse {
  error: GetOrderPrintableVersionError;
}

export interface GetOrderPrintableVersionResponse {
  html: string;
}

export interface GetOrdersApiResponseV2 {
  orders: OrderPreviewV2[];
  preOrders: PreOrderPreview[];
}

export interface HideOrderFromHistoryErrorResponseV2 {
  error: HideOrderFromHistoryErrorV2;
}

export interface OrderItemPreview {
  hxid: string | null;
  title: string | null;
}

export interface OrderPreviewV2 {
  /** Код заказа */
  code: string;
  /** Статус */
  status: OrderStatusV2;
  /** Дата оформления */
  createdOn: Date | null;
  /** Сумма оплаты */
  paymentAmount: number | null;
  /** Валюта */
  currency: CurrencyModel | null;
  /** Стоимость оплаты изменилась */
  paymentAmountChanged: boolean;
  /** Дата готовности */
  willReadyOn: Date | null;
  /** Можно показать подробную информацию */
  canShowDetails: boolean;
  canCancel: boolean;
  /** Можно ли отменить заказ */
  canCancelOrder: boolean;
  /** Можно ли отменить оплату */
  canCancelPayment: boolean;
  /** Исследования в заказе */
  items: OrderItemPreview[] | null;
  /** Статус оплаты */
  paymentStatus: DraftOrderPaymentStatus;
}

/** Человек */
export interface Person {
  /** Фамилия */
  lastName: string;
  /** Имя */
  firstName: string;
  /** Отчество */
  middleName: string;
  /** Дата рождения */
  birthDate: Date | null;
}

/** Полная информация о партенерах */
export interface PartnerInfo {
  /** Идентификатор партнера */
  id: number;
  /** Имя */
  title: string | null;
  /** Город */
  city: string | null;
  /** Адрес сайта */
  site: string | null;
  /** Дополнительная информация */
  info: string | null;
  /** Относительный адрес логотипа */
  logoRelativePath: string | null;
}

export interface HidePreOrderFromHistory {
  profileId: number;
}

export enum GetPreOrderError {
  Unauthorized = 'Unauthorized',
}

/** Тип ответа на запрос получения печатной версии предзаказа */
export enum GetPreOrderPrintResponseType {
  PreOrderHtml = 'PreOrderHtml',
  NotAvailableInRegion = 'NotAvailableInRegion',
}

export enum GetPreOrderPrintVersionError {
  Unauthorized = 'Unauthorized',
}

export enum HidePreOrderFromHistoryError {
  Unauthorized = 'Unauthorized',
}

export enum RepeatOrderError2 {
  Unauthorized = 'Unauthorized',
}

export enum TryRepeatOrderError2 {
  Unauthorized = 'Unauthorized',
}

export interface GetPreOrderErrorResponse {
  error: GetPreOrderError;
}

/** Ответ на запрос для получения печатной версии предзаказа */
export interface GetPreOrderPrintApiResponse {
  /** Тип ответа */
  responseType: GetPreOrderPrintResponseType;
  /** HTML предзаказа */
  readonly preOrderHtml: string | null;
}

export interface GetPreOrderPrintVersionErrorResponse {
  error: GetPreOrderPrintVersionError;
}

export interface HidePreOrderFromHistoryErrorResponse {
  error: HidePreOrderFromHistoryError;
}

export interface PreOrder {
  /** Код предзаказа */
  code: string;
  /** Фамилия */
  lastName: string;
  /** Имя */
  firstName: string;
  /** Отчество */
  middleName: string;
  /** Дата оформления */
  createdOn: Date;
  /** Сумма предварительного заказа */
  sum: number;
  /** Валюта */
  currency: string;
  /** Код валюты */
  currencyCode: string;
  /** Заказанные анализы */
  items: PreOrderItem[];
  /** Заказанные услуги */
  biomaterialServices: PreOrderItem[];
  /** Рекомендации по подготовке к исследованиям */
  preparations: string[];
  mobileServiceAddress: string;
  mobileServiceVisitDate: Date | null;
}

/** Анализ\услуга */
export interface PreOrderItem {
  /** Номенклатура */
  hxid: string;
  /** Наименование */
  title: string;
  /** Цена */
  price: number;
  /** Список ДЦ, в которых доступно исследование */
  centersWhereItemIsAvailable: string[];
  /** Список исследований, входящих в комплекс */
  parts: PreOrderItemPart[];
}

/** Дочернее исследование в комплексе */
export interface PreOrderItemPart {
  /** Номенклатура */
  hxid: string;
  /** Наименование */
  title: string;
}

export interface RepeatOrderErrorErrorResponse {
  error: RepeatOrderError2;
}

export interface TryRepeatOrderErrorErrorResponse {
  error: TryRepeatOrderError2;
}

export interface DeleteProfileCommand {
  /** Идентификатор профиля клиента */
  profileId: number;
}

export interface UpdateProfileCommand {
  /** Идентификатор профиля клиента */
  profileId: number;
  /** Фамилия клиента */
  lastName: string;
  /** Имя клиента */
  firstName: string;
  /** Отчество клиента */
  middleName: string;
  /** Дата рождения клиента */
  birthDate: Date;
  /** Пол клиента */
  gender: Gender;
  /** Номер телефона */
  cellPhone: string;
  /** Адрес электронной почты */
  email: string | null;
}

export interface CreateProfileRequest {
  lastName: string;
  firstName: string;
  middleName: string;
  birthDate: Date;
  gender: Gender;
  phone: string;
  email: string | null;
}

export interface SetCurrentProfileRequest {
  id: number | null;
}

export interface AccountInfoResponse {
  /** Профили пользователя */
  profiles: GetAllProfilesResponse[] | null;
  /** Баланс карты лояльности */
  cardBalance: number;
  /** Email - общий для аккаунта */
  email: string | null;
  /** Номер карты лояльности */
  cardNumber: string | null;
}

export interface CreateProfileErrorResponse {
  error: string | null;
}

export interface GetAllProfilesResponse {
  id: number;
  lastName: string;
  firstName: string;
  middleName: string;
  birthDate: Date | null;
  gender: string;
  email: string;
  phoneMobile: string;
}

/** Описывает данные профиля */
export interface ProfileInfo {
  id: number;
  lastName: string | null;
  firstName: string | null;
  middleName: string | null;
  birthDate: Date | null;
  /** Общее перечисление, описывающее пол клиента. */
  gender: Gender;
  email: string | null;
  phone: string | null;
}

export interface ProfileResponse {
  id: number;
  lastName: string;
  firstName: string;
  middleName: string;
  birthDate: Date | null;
  /** Общее перечисление, описывающее пол клиента. */
  gender: Gender;
  email: string | null;
  phone: string | null;
  cardBalance: number;
}

export interface Publication {
  id: number;
  publisherName: string | null;
  title: string | null;
  content: string | null;
  publishDate: Date;
  url: string | null;
  categoryId: number;
  imageLink: string | null;
  tagIds: number[] | null;
}

export interface PublicationSearchFilter {
  publicationTagIds: number[] | null;
  publicationCategoriesIds: number[] | null;
  publisherNameQuery: string | null;
  contentQuery: string | null;
  fromDate: Date | null;
  toDate: Date | null;
}

export interface PublicationSearchRequest {
  filter: PublicationSearchFilter | null;
  pagination: PaginationFilter | null;
}

export interface PublicationCategoryResponse {
  id: number;
  name: string | null;
  image: string | null;
}

export interface PublicationSearchResponse {
  count: number;
  publications: Publication[] | null;
}

export interface PublicationTagResponse {
  id: number;
  name: string | null;
}

export interface SearchCommand {
  searchQuery: string | null;
}

export interface AddressSearchResult {
  code: string | null;
  accountName: string | null;
  cityName: string | null;
  metroName: string | null;
  address: string | null;
}

export interface CatalogSearchResult {
  hxid: string | null;
  description: string | null;
  canBePreOrder: boolean;
  isPreOrdered: boolean;
  price: number;
  currency: string | null;
}

export interface KnowledgeBaseSearchResult {
  id: number;
  hxid: string | null;
  title: string | null;
}

export interface PromotionSearchResult {
  id: number;
  title: string | null;
  description: string | null;
}

export interface SearchResponse {
  isOrderNumber: boolean;
  catalogSearchResult: CatalogSearchResult[] | null;
  promotionSearchResult: PromotionSearchResult[] | null;
  knowledgeBaseSearchResult: KnowledgeBaseSearchResult[] | null;
  addressSearchResult: AddressSearchResult[] | null;
}

export interface ChangeEmailRequest {
  currentEmail: string;
  newEmail: string;
}

export interface ChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
}

/** Описывает авторизационные данные клиента */
export interface ForgetPassRequest {
  /** Почта */
  email: string;
}

/** Описывает авторизационные данные клиента */
export interface LoginRequest {
  /** Почта */
  email: string;
  /** Пароль */
  password: string;
}

export interface AddServiceCardRequest {
  cardCode: string;
  orderCode: string;
}

export interface CombineAccountsRequest {
  secondaryEmail: string;
  secondaryPassword: string;
  /** Заменить\перенести карту лояльности со второго аккаунта */
  replaceOrMoveLoyaltyCardFromSecondaryWebAccount: boolean;
}

export interface AddServiceCardErrorResponse {
  error: string | null;
}

export interface ChangeEmailErrorResponse {
  error: string | null;
}

export interface ChangePasswordErrorResponse {
  error: ChangePasswordError;
}

export interface CombineAdditionalQuestionResponse {
  type: CombineAdditionalQuestionResponseType;
}

export interface CombineErrorResponse {
  error: string | null;
}

export interface DeleteAccountResponse {
  deleted: boolean;
  daysBeforeDelete: number | null;
}

export enum ChangePasswordError {
  WrongOldPassword = 'WrongOldPassword',
  NotStrongEnoughPassword = 'NotStrongEnoughPassword',
}

export enum CombineAdditionalQuestionResponseType {
  None = 'None',
  ReplaceCard = 'ReplaceCard',
  MoveCard = 'MoveCard',
}

export enum ForgetPassError {
  SuchUserNotRegisteredAsClient = 'SuchUserNotRegisteredAsClient',
  SuchUserNotRegistered = 'SuchUserNotRegistered',
}

export interface GetCurrentUserAccountResponse {
  email: string;
}

export interface GetEmailsResponse {
  commonEmails: string[] | null;
}

export interface GetPhonesResponse {
  phones: string[] | null;
}

/** Описывает результат авторизации пользователя на сайте */
export interface LoginResult {
  status: LoginResultStatus;
  info: string | null;
}

export enum LoginResultStatus {
  Success = 'Success',
  AlreadyLoggedIn = 'AlreadyLoggedIn',
}

export interface RestoreAccountResponse {
  result: boolean;
}

export interface AddAddressRequest {
  city: string | null;
  street: string | null;
  house: string | null;
  housing: string | null;
  flat: string | null;
}

export interface AddFavouriteCenterRequest {
  accountCode: string;
}

export interface DeleteAddressRequest {
  id: number;
}

export interface DeleteFavouriteCenterRequest {
  id: number;
}

export interface UpdateAddressRequest {
  id: number;
  city: string | null;
  street: string | null;
  house: string | null;
  housing: string | null;
  flat: string | null;
}

export interface AddressResponse {
  /** Id */
  id: number;
  /** Город */
  city: string | null;
  /** Улица */
  street: string | null;
  /** Номер дома */
  house: string | null;
  /** Корпус (если есть) */
  housing: string | null;
  /** Номер квартиры */
  flat: string | null;
}

export interface GetAddressesResponse {
  /** Список адресов */
  addressList: AddressResponse[] | null;
}

export interface GetAllFavouriteCentersResponse {
  accountCode: string | null;
  accountName: string | null;
  id: number;
  personalId: number;
}

export interface CompanionBiomaterialServiceModel {
  hxid: string | null;
  title: string | null;
  currency: CurrencyModel | null;
  price: number;
}

export enum AccountPaymentStatus {
  Accept = 'Accept',
  Decline = 'Decline',
  Unknown = 'Unknown',
  Custom = 'Custom',
}

export enum PaymentType {
  Offline = 'Offline',
  Online = 'Online',
}

export interface ErrorDetails {
  statusCode: number;
  message: string;
  source: string;
}

export interface BiomaterialService {
  hxid: string | null;
  title: string | null;
  price: number;
}

export interface FullBiomaterialRuleDto {
  biomaterialDescription: string | null;
  biomaterialServices: BiomaterialService[] | null;
  isHome: boolean;
  isDiagnosticCenter: boolean;
  isSelf: boolean;
  isAvailableForMobileService: boolean;
  isRequired: boolean;
}

export interface ServiceCostPredictionDto {
  minimalServicesCost: number;
  canCostBeHigher: boolean;
}

export interface Unit {}

export interface ProblemDetails {
  type: string | null;
  title: string | null;
  status: number | null;
  detail: string | null;
  instance: string | null;
}

export interface FileParameter {
  data: any;
  fileName: string;
}

export interface FileResponse {
  data: Blob;
  status: number;
  fileName?: string;
  headers?: { [name: string]: any };
}
